/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AccessionPOST = {
    readonly id?: number;
    prefix_id: number;
    lab_id: number;
    lab_station_id: number;
    clinic_id?: number | null;
    ordering_doctor_id?: number | null;
    supervising_physician_id?: number | null;
    screen_assignment_id?: number;
    finalize_assignment_id?: number;
    active_assignment_id?: number;
    collected_date?: string | null;
    received_date?: string | null;
    patient?: any;
    address?: any;
    insurance?: any;
    specimens?: any;
    guarantor?: any;
    /**
     * case billing type: Global Bill, Client Bill, Cash Pay, or No Bill
     */
    billing_type?: AccessionPOST.billing_type | null;
    /**
     * True if the patient is paying cash; i.e. no insurance. Aka self-pay
     */
    self_pay?: boolean;
    /**
     * True if the patient is paying cash with an attestation; i.e. no insurance. Aka self-pay with attestation
     */
    self_pay_with_attestation?: boolean;
    /**
     * True if the patient has an indigent pay agreement.
     */
    indigent?: boolean;
    /**
     * case type: Clinical, Test, Demo, Validation, Consult, TC PC Split, or Historical
     */
    case_type?: AccessionPOST.case_type;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    /**
     * EZDerm's order id that, with patient name, matches the case in their system
     */
    external_ezderm_order_id?: string | null;
    /**
     * Non-EZDerm order id for integrations.
     */
    external_order_id?: string | null;
    /**
     * True if we're billing for TC (technical component - lab) work, False if someone else bills.
     */
    bill_tc?: boolean;
    /**
     * True if we're billing for PC (professional component - pathologist) work, False if someone else bills.
     */
    bill_pc?: boolean;
    priority?: AccessionPOST.priority;
    grossed_by_external_lab_id?: number | null;
}

export namespace AccessionPOST {

    /**
     * case billing type: Global Bill, Client Bill, Cash Pay, or No Bill
     */
    export enum billing_type {
        GLOBAL = 'global',
        CLIENT = 'client',
        NONE = 'none',
    }

    /**
     * case type: Clinical, Test, Demo, Validation, Consult, TC PC Split, or Historical
     */
    export enum case_type {
        CLINICAL = 'clinical',
        TEST = 'test',
        DEMO = 'demo',
        VALIDATION = 'validation',
        CONSULT = 'consult',
        CONTROL = 'control',
        TC_PC = 'tc-pc',
        HISTORICAL = 'historical',
        EDUCATION = 'education',
        NON_DIAGNOSTIC = 'non-diagnostic',
        MOHS_QC = 'mohs-qc',
        TRIAGE = 'triage',
    }

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }


}
